import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';

const resources = {
  es: { translation: es },
  en: { translation: en },
  fr: { translation: fr },
  de: { translation: de },
};

const defaultLng =
  typeof navigator !== 'undefined'
    ? navigator.language?.startsWith('en')
      ? 'en'
      : navigator.language?.startsWith('fr')
        ? 'fr'
        : navigator.language?.startsWith('de')
          ? 'de'
          : 'es'
    : 'es';

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLng,
  fallbackLng: 'es',
  supportedLngs: ['es', 'en', 'fr', 'de'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
